<h4>{{ 'COMMON.SEARCH_TYPE' | translate }}</h4>
<div class="search-options">
  <div class="option" (click)="onSearchType(AdvancedMapSearchType.Location)">
    <span>{{ 'COMMON.LOCATION' | translate }}</span>
  </div>
  <div class="option d-flex align-items-center justify-content-between" (click)="openAssetNameDropdown()">
    <span>{{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.ASSET_NAME' | translate }}</span>
    <img [class.rotated]="assetNameDropdownOpened" height="16" width="16" src="../../../../assets/icons/arrow-down-small.svg"/>
  </div>
  <div *ngIf="assetNameDropdownOpened" class="dropdown-body asset-name-dropdown">
    <ng-container *ngIf="!hasCimDataIntegration">
      <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetName_TS)">
        <div class="dropdown-option-wrapper">
          <span>
            {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.TRANSMISSION_STATION' | translate }}
          </span>
        </div>
      </div>
      <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetName_IS)">
        <div class="dropdown-option-wrapper">
          <span>
            {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.INJECTION_SUBSTATION' | translate }}
          </span>
        </div>
      </div>
      <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetName_DS)">
        <div class="dropdown-option-wrapper">
          <span>
            {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.DISTRIBUTION_SUBSTATION' | translate }}
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hasCimDataIntegration">
      <div class="dropdown-option" *ngFor="let template of substationTemplates" (click)="onCimTemplateSearchType(template)">
        <div class="dropdown-option-wrapper">
          <span>
            {{ template.className }}
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!hasCimDataIntegration">
      <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetName_F33)">
        <div class="dropdown-option-wrapper">
          <span>
            {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.MAIN_FEEDER' | translate }}
          </span>
        </div>
      </div>
      <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetName_F11)">
        <div class="dropdown-option-wrapper">
          <span>
            {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.SECONDARY_FEEDER' | translate }}
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hasCimDataIntegration">
      <div class="dropdown-option" *ngFor="let lineType of acLineSegmentTypes" (click)="onCimAcLineTypeSearchType(lineType)">
        <div class="dropdown-option-wrapper">
          <span>
            {{ lineType.name | translate }}
          </span>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="option d-flex align-items-center justify-content-between" (click)="openAssetSlrnDropdown()">
    <span>{{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.ASSET_SLRN' | translate }}</span>
    <img [class.rotated]="assetSlrnDropdownOpened" height="16" width="16" src="../../../../assets/icons/arrow-down-small.svg"/>
  </div>
  <div *ngIf="assetSlrnDropdownOpened" class="dropdown-body asset-slrn-dropdown">
    <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetSlrn_DS)">
      <div class="dropdown-option-wrapper">
        <span>
          {{ (hasCimDataIntegration ? 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.SUBSTATION' : 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.DISTRIBUTION_SUBSTATION') | translate }}
        </span>
      </div>
    </div>
    <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetSlrn_LVPole)">
      <div class="dropdown-option-wrapper">
        <span>
          {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.LV_POLE' | translate }}
        </span>
      </div>
    </div>
    <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetSlrn_Building)">
      <div class="dropdown-option-wrapper">
        <span>
          {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.BUILDING' | translate }}
        </span>
      </div>
    </div>
    <div class="dropdown-option" (click)="onSearchType(AdvancedMapSearchType.AssetSlrn_Meter)">
      <div class="dropdown-option-wrapper">
        <span>
          {{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.METER' | translate }}
        </span>
      </div>
    </div>
  </div>
  <div class="option" (click)="onSearchType(AdvancedMapSearchType.AccountNumber)">
    <span>{{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.ACCOUNT_NUMBER' | translate }}</span>
  </div>
  <div class="option" (click)="onSearchType(AdvancedMapSearchType.MeterNumber)">
    <span>{{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.METER_NUMBER' | translate }}</span>
  </div>
</div>
